module.exports = __webpack_public_path__ + "img/USDT-alt.ff410a3b.svg";